import React, { useState,useEffect } from "react";
import Card from "../../Components/Atoms/Card/Card";
import { FormField } from "../../Components/Molecules/FormField/FormField";
import { useFormik } from "formik";
import styles from "./Login.module.scss";
import Logo from "../../Assests/Images/tfs_logo.png";
import session from "../../Assests/Images/session.png";
import { PrimaryButton } from "../../Components/Atoms/Button/Button";
import * as Yup from "yup";
import ErrorLabel from "../../Components/Atoms/ErrorLabel/ErrorLabel";
import { useNavigate } from "react-router-dom";
import { showToast } from "../../Components/Atoms/ToastNotifier/ToastNotifier";
import {postMethod} from "../../Helpers/services"
import _ from "lodash";
import { useDispatch,useSelector } from "react-redux";
import {loginauth} from "../../ReduxStore/UserStore"
import { login_url,forgot_password } from "../../Enums/api_constunts";


export const Login = () => {
  const navigateTo = useNavigate()
  const [isSpinner, setIsSpinner] = useState(false);
const dispatch = useDispatch()
  const handleSubmit = (values) => {
    setIsSpinner(true);
    console.log(values);
    postMethod(login_url,values).then((result)=>{
     console.log(result)
      setIsSpinner(false);
      dispatch(loginauth(result.result));
      navigateTo("/dashboard")
    }).catch((error)=>{
      showToast("error",_.get(error, "message","Something went wrong!"))
      setIsSpinner(false);
      
    })
    
    // showToast("success", "login successfully!");
    // setTimeout(() => {
    //   setIsSpinner(false);
    //   navigateTo("/dashboard")
    //   // showToast("", "login successfully!");
    // }, 2000)
    
  }
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email format")
        .required("Please enter your email"),
        password: Yup.string()
        .min(4, "Password must be at least 8 characters")
        .max(16, "Password cannot exceed 16 characters")
       // .matches(/[A-Z]/, "Password must contain at least 1 uppercase letter")
        //.matches(/[a-z]/, "Password must contain at least 1 lowercase letter")
        //.matches(/[0-9]/, "Password must contain at least 1 number")
        //.matches(/[@$!%*?&]/, "Password must contain at least 1 special character")
        .required("Please enter your password"),
    }),
    onSubmit:handleSubmit 
  });

  const handleKeyDown = (event) => {
    
    if (event.key === 'Enter') {
      
      formik.handleSubmit()
      
    }
  };
  const userData = useSelector((state) => state.auth.user);
  useEffect(()=>{
    if(_.get(userData,"token","")){
      navigateTo("/dashboard")
    }
  },[userData])

  useEffect(() => {
    const interval = setInterval(() => {
      console.log(1)
      // Check email input
      const emailInput = document.getElementById('email');
      if (emailInput?.value) {
        formik.setFieldValue('email', emailInput.value);
      }
      
      // Check password input
      const passwordInput = document.getElementById('password');
      if (passwordInput?.value) {
        formik.setFieldValue('password', passwordInput.value);
      }
    }, 1000);

    // Clear after 10 seconds
    const timeout = setTimeout(() => {
      clearInterval(interval);
    }, 10000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    }
  }, []);

  return (
    <div className={styles.card} autoComplete="off">
      <Card className={styles.cardContent}>
        <div className="text-center">
          <img src={Logo} alt="logo" height="70px" />
          <p className="d-flex flex-column mt-1">
            <span className={`fs-2 lh-1 fw-bold ${styles.loginTitle}`}>
              Login
            </span>
            <span className="fs-6 lh-1 mt-3">Welcome back!</span>
          </p>
        </div>
        <div onKeyDown={handleKeyDown}>
          <FormField
            label="Email Address"
            id="email"
            name="email"
            type="email"
            value={formik.values.email}
            onChange={(e) => formik.setFieldValue("email", e.target.value)}
            error={formik.touched.email && formik.errors.email}
            disableNumbers={false}
            disableSymbols={false}
            isImportant={false}
            onBlur={formik.handleBlur}
            autoComplete={false}
            className={styles.emailField}
            focus={true}
          />
          {formik.touched.email && <ErrorLabel name="email" formik={formik} />}
        </div>
        <div className="mb-3 position-relative" onKeyDown={handleKeyDown}>
          <FormField
            label="Password"
            placeholder="Enter your password"
            type="password"
            id="password"
            name="password"
            autoComplete={false}
            value={formik.values.password}
            onChange={(e) => formik.setFieldValue("password", e.target.value)}
            error={formik.touched.password && formik.errors.password}
            onBlur={formik.handleBlur}
            className={styles.emailField}
            focus={true}
          />
          {formik.touched.password && <ErrorLabel name="password" formik={formik} className={styles.errorMessage}/>}
          <p className={styles.forgotPassword} onClick={()=>navigateTo("/forgot-password")}>Forgot Password</p>
        </div>
        <div className="text-center" onClick={formik.handleSubmit}>
          <PrimaryButton
            label="Login"
            className={styles.loginButton}
            //onClick={formik.handleSubmit}
            disabled={!(formik.dirty && formik.isValid)}
            spinner={isSpinner}
          />
        </div>
        <p className={styles.createAccount}>
          Don't have account with us <span className={styles.creteNow} onClick={()=>navigateTo("/create-user-account")}>Signup Now!</span>
        </p>
      </Card>
    </div>
  );
}

export const ForgotPassword = ({customer=0}) => {
  const navigateTo = useNavigate()
  const [isSpinner, setIsSpinner] = useState(false);

  const handleSubmit = (values)=>{
    setIsSpinner(true);
    values["customer"] = customer;
    postMethod(forgot_password,values).then((result)=>{
     console.log(result)
      setIsSpinner(false);
      
      showToast("success",_.get(result, "message","Something went wrong!"))
      navigateTo("/")
    }).catch((error)=>{
      showToast("error",_.get(error, "message","Something went wrong!"))
      setIsSpinner(false);
      
    })
  }
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email format")
        .required("Please enter your email"),
    }),
    onSubmit: handleSubmit,
  })
  const handleKeyDown = (event) => {
    
    if (event.key === 'Enter') {
      
      formik.handleSubmit()
      
    }
  };
  const userData = useSelector((state) => state.auth.user);
  useEffect(()=>{
    if(_.get(userData,"token","")){
      navigateTo("/dashboard")
    }
  },[userData])
  return (
    <div className={styles.card}>
    <Card className={styles.cardContent}>
      <div className="text-center">
        <img src={Logo} alt="logo" height="70px" />
        <p className="d-flex flex-column mt-1">
          <span className={`fs-2 lh-1 fw-bold ${styles.loginTitle}`}>
          Forgot password
          </span>
          <span className={styles.forgotPassowrd}>To reset your password, please enter your registered email.</span>
        </p>
      </div>
      <div onKeyDown={handleKeyDown}>
        <FormField
          label="Email Address"
          id="email"
          name="email"
          type="email"
          value={formik.values.email}
          onChange={(e) => formik.setFieldValue("email", e.target.value)}
          error={formik.touched.email && formik.errors.email}
          disableNumbers={false}
          disableSymbols={false}
          isImportant={false}
          onBlur={formik.handleBlur}
          className={styles.emailField}
        />
        {formik.touched.email && <ErrorLabel name="email" formik={formik} />}
      </div>
     
      <div className="text-center">
        <PrimaryButton
          label="Submit"
          className={styles.loginButton}
          onClick={formik.handleSubmit}
          disabled={!(formik.dirty && formik.isValid)}
          spinner={isSpinner}
        />
      </div>
      <p className={styles.createAccount}>
       <span className={styles.creteNow} onClick={()=>navigateTo("/login")}>Back to login</span>
      </p>
    </Card>
  </div>
  );
};

export const SessionTimeout = () => {
  const dispatch = useDispatch()
  const navigateTo = useNavigate()
const roleId = useSelector((store) => store?.auth?.user?.role_id);
dispatch(loginauth({}));
const handleSubmit = () => {
  let loginurl = "/";
  
  dispatch(loginauth({}));
  if(roleId==5){
    loginurl = "/customer-login";
  }
  navigateTo("/");
};

return (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      height: "100vh",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <img src={session}></img>
    <div style={{ margin: "20px 0px" }}>
      <h1 style={{ textAlign: "center" }}>OOPS...!</h1>
      <p>Your session has expired. Please Login Again</p>
    </div>
    
    <PrimaryButton
          label="Go To Login Page"
          //className={styles.loginButton}
          backgroundColor="#FE9003"
          onClick={handleSubmit}
          
        />
  </div>
);
};


